export default function EngagementCard({ title, body }) {
  return (
    <div
      className="group p-7 border border-black/10 bg-brand-surface/50 hover:bg-brand-surface transition-all duration-250 hover:-translate-y-1 hover:shadow-xl"
      data-testid={`engagement-${title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
    >
      <h4 className="font-display text-lg font-semibold text-brand-primary group-hover:text-brand-accent transition-colors">
        {title}
      </h4>
      <p className="mt-4 text-[15px] text-brand-text leading-relaxed">{body}</p>
    </div>
  );
}
